<template>
  <div class="container">
    <div class="row" v-if="ActionName !== undefined">
      <button
        type="submit"
        v-on:click.prevent="$emit('executeAction')"
        class="btn btn-primary col-md order-md-last m-2"
      >{{ActionName}}</button>
    </div>
    <div class="row">
      <button
        type="button"
        v-on:click="$emit('executeCancel')"
        class="btn btn-primary col-md order-md-first m-2"
      >Abbrechen</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "User.Menu.ButtonBar",
  props: {
    ActionName: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
